import { GET_DRIVER, GET_DRIVER_BY_ID } from "../constants/index";

export const driver = (state = { driverlist: [], driverbyid: {} }, action) => {
  switch (action.type) {
    case GET_DRIVER:
      return { ...state, driverlist: action.driverlist };
    case GET_DRIVER_BY_ID:
      return { ...state, driverbyid: action.driverbyid };
    default:
      return state;
  }
};
